import { render } from "./UserCenterView.vue?vue&type=template&id=38ce7c6d&scoped=true"
import script from "./UserCenterView.vue?vue&type=script&lang=js"
export * from "./UserCenterView.vue?vue&type=script&lang=js"

import "./UserCenterView.vue?vue&type=style&index=0&id=38ce7c6d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ce7c6d"]])

export default __exports__